// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---gatsby-theme-instore-core-src-screens-instore-index-tsx": () => import("./../../../../gatsby-theme-instore-core/src/screens/Instore/index.tsx" /* webpackChunkName: "component---gatsby-theme-instore-core-src-screens-instore-index-tsx" */),
  "component---gatsby-theme-instore-core-src-screens-redirect-index-tsx": () => import("./../../../../gatsby-theme-instore-core/src/screens/Redirect/index.tsx" /* webpackChunkName: "component---gatsby-theme-instore-core-src-screens-redirect-index-tsx" */)
}

